import { render, staticRenderFns } from "./CollectionsComponent.vue?vue&type=template&id=0c1d1fe4&scoped=true&"
import script from "./CollectionsComponent.vue?vue&type=script&lang=js&"
export * from "./CollectionsComponent.vue?vue&type=script&lang=js&"
import style0 from "./CollectionsComponent.vue?vue&type=style&index=0&id=0c1d1fe4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1d1fe4",
  null
  
)

export default component.exports